import MonitorCV from "./controladorVista/monitorCV";

export const Monitor = () => {
    return (
        <MonitorCV />
    );
};
